export default __webpack_public_path__ + "static/media/venus.42e108f5.png";